import React from 'react';

import { useTranslation } from 'react-i18next';
import { PreOrderDisabledResult } from '../../../utils/preOrderDisabled';

interface FoodSuggestItemProps {
  name: string;
  image: string;
  price?: number;
  preOrderStatus?: PreOrderDisabledResult;
}

const FoodSuggestItem: React.FC<FoodSuggestItemProps> = ({ name, image, price, preOrderStatus }) => {
  const { t } = useTranslation();

  const isDisabled = preOrderStatus?.disabled === true;
  const reason = preOrderStatus?.reason;


  return (
    <div className="flex-shrink-0 min-w-[140px]">
      <div className="flex items-start flex-col justify-center bg-white px-4 pt-3 rounded-lg shadow-md min-w-[140px]">
        <img src={image} alt={name} className="w-[140px] h-[140px] shrink-0 rounded-lg object-cover" />
        <div className="mt-2 w-[140px]">
          <p className="text-gray-800 text-sm font-medium not-italic leading-5 text-clip w-[130px] overflow-hidden">{name}</p>
          {price && (
            <p className="text-green-500 font-medium pb-3">¥ {price}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FoodSuggestItem;
